const eRemediationTab = {
  CustomRem: { value: 1, name: 'Custom Remediation' },
  PlayBook: { value: 2, name: 'PlayBook' },
  ExecutionServers: { value: 3, name: 'Execution Servers' }
};

export default eRemediationTab;
